// OrganizationDetails.js

import React, { useEffect, useState } from "react";
import { deepCopy } from "components/helpers/stateReducer";
import OrganizationDetailsView from "./OrganizationDetailsView";
import OrganizationDetailsEdit from "./OrganizationDetailsEdit";

const Subscriber = () => {
	const _theme = window.main.theme;

	const [customerObjState, customerObjSetState] = useState(()=>{
		const _data = window.main.lib.getCurrentViewObj().currentViewData;
		if (!!_data && typeof(_data)==="object" && !!_data.hasOwnProperty("organization_id")) {
			return _data;
		}
		return null;
	});

	const getOrgDetails = async (refresh=false)=>{
		const _url_org_id = (Number(window.main.lib.getWebUrlParam("view"))||0);
		if (!refresh && !customerObjState) {
			if (!_url_org_id) {
				window.main.lib.setCurrentView("subscribers");
			}
		}
		if (!_url_org_id && !!customerObjState && !!Number(customerObjState.organization_id)) {
			_url_org_id = Number(customerObjState.organization_id);
		}
		if (!!_url_org_id) {
			window.main.lib.setLoadingState(true);
			if (!refresh && !!customerObjState && typeof(customerObjState)==="object" && !!Number(customerObjState.organization_id)) {
				// Return existing cached org details.
				getOrgAdditionalData(customerObjState);  // ⬅ Only setState once in the next function.
				return customerObjState;
			}
			try {
				// Pull fresh org details from API.
				const customerResult = await window.main.axios.get(window.main.api.organization.replace("{organization_id}",_url_org_id));
				getOrgAdditionalData(customerResult.data);  // ⬅ Only setState once in the next function.
			} catch (err) {
				// triggerAlert({
				// 	show: true,
				// 	title: "Submission Error",
				// 	message: window.main.lib.parseErrorMessage(err),
				// });
				window.main.lib.setStatusState(_currentStatus + (!!_currentStatus ? ", " : "") + window.main.lib.parseErrorMessage(err));
			}
		} else {
			// Else: Default to new form:
			customerObjSetState({
				organization_id: 0,
				name: "",
				shortname: "",
				shortname: "",
				public_phone: "",
				pulic_email: "",
				public_website: "",
				public_facebook: "",
				public_instagram: "",
				is_editing: true,
			});
			window.main.lib.setLoadingState(false);  // ⬅ Done!
		}
	};

	const getOrgAdditionalData = async (orgDetails)=>{
		const _org_id = (Number(orgDetails.organization_id)||0);
		if (!_org_id) {
			window.main.lib.setLoadingState(false);  // ⬅ Done!
			return [];
		}
		const locations = await getOrgLocations(_org_id);
		const staff = await getOrgStaff(_org_id);
		// Ready
		const _tempState = deepCopy(orgDetails);
		_tempState.locations = locations;
		_tempState.staff = staff;
		customerObjSetState(_tempState);  // ⬅ Only setState once here.
		window.main.lib.setLoadingState(false);  // ⬅ Done!
	};

	const getOrgLocations = async (_org_id)=>{
		try {
			// Pull fresh org details from API.
			const result = await window.main.axios.get(window.main.api.orgLocations.replace("{organization_id}",_org_id));
			return result.data;
		} catch (err) {
			const _currentStatus = window.main.lib.getStatusState();
			window.main.lib.setStatusState(_currentStatus + (!!_currentStatus ? ", " : "") + "Failed to load Locations data.");
			return [];
		}
	};

	const getOrgStaff = async (_org_id)=>{
		try {
			// Pull fresh org details from API.
			const result = await window.main.axios.get(window.main.api.orgStaff.replace("{organization_id}",_org_id));
			return result.data;
		} catch (err) {
			const _currentStatus = window.main.lib.getStatusState();
			window.main.lib.setStatusState(_currentStatus + (!!_currentStatus ? ", " : "") + "Failed to load Locations data.");
			return [];
		}
	};

	useEffect(()=>{
		getOrgDetails();
	},[]);

	// const [viewEditState, viewEditSetState] = useState(customerObjState.organization_id);  // ⬅ Blank means 'View All', nothing in edit mode.

	const onToggleEditOrgDetails = async ()=>{
		// When toggling out of edit mode for NEW ORG, then revert back to Home List of Organizations:
		if (customerObjState.organization_id===0 && !!customerObjState.is_editing) {
			return window.main.lib.setCurrentView("/subscribers");
		}
		const _tempState = deepCopy(customerObjState);
		_tempState.is_editing = !_tempState.is_editing;
		customerObjSetState(_tempState);  // ⬅ Only setState once here.
	};
	// console.log("viewEditState =", viewEditState);


	// if (viewEditState==="editOrgDetails") {
	// console.log("customerObjState =", customerObjState);
	if (!!customerObjState && !!customerObjState.is_editing) {
		return (<OrganizationDetailsEdit customerObjState={customerObjState} customerObjSetState={customerObjSetState} getOrgDetails={getOrgDetails} onToggleEditOrgDetails={onToggleEditOrgDetails} />);
	}
	return (<OrganizationDetailsView customerObjState={customerObjState} onToggleEditOrgDetails={onToggleEditOrgDetails} />);
};

export default Subscriber;
